import React from 'react';

import {colors} from 'styles/shared';

function Icon(props) {
  let color = props.color || colors.blue_main;

  return (
    <svg width="22" height="21" fill="none" viewBox="0 0 22 21">
      <path
        fill={color}
        d="M21.625 8.442L11.562.208a.915.915 0 00-1.162 0L.336 8.442A.917.917 0 101.498 9.86l1.248-1.024v8.55a2.745 2.745 0 002.745 2.744H16.47a2.745 2.745 0 002.745-2.745v-8.55l1.248 1.025c.164.134.37.207.581.206a.915.915 0 00.581-1.624zM9.151 18.3v-4.574a.915.915 0 01.915-.915h1.83a.915.915 0 01.914.915V18.3H9.15zm8.234-.915a.915.915 0 01-.915.915h-1.83v-4.574a2.745 2.745 0 00-2.745-2.745h-1.83a2.745 2.745 0 00-2.744 2.745V18.3H5.49a.915.915 0 01-.915-.915V7.321l6.404-5.224 6.405 5.224v10.064z"></path>
    </svg>
  );
}

export default Icon;
